import { Score } from "src/types";
import { ScoreWithVariation } from "src/services/ScoreService";

export const isActionPlanEligibleScore = (score: Score, actionPlanScoreIds: number[]): boolean =>
    score.isActionPlanAvailable && actionPlanScoreIds.includes(score.id);

export const scoreHasBaseline = (score: Score): boolean => score.hasBaseline !== false;

export const filterActionPlanEligibleScores = (scores: Score[], actionPlanScoreIds: number[]): Score[] =>
    scores.filter((score) => isActionPlanEligibleScore(score, actionPlanScoreIds));

export const filterScoresWithVariationsForSelectors = (
    scoresWithVariations: ScoreWithVariation[],
    selectorScores: Score[],
): ScoreWithVariation[] => {
    const selectorScoreIds = new Set(selectorScores.map((score) => score.id));
    return scoresWithVariations.filter((row) => selectorScoreIds.has(row.scoreId));
};

export const filterScoresWithVariationsForEligibleScores = (
    scoresWithVariations: ScoreWithVariation[],
    eligibleScores: Score[],
): ScoreWithVariation[] => {
    const eligibleScoreIds = new Set(eligibleScores.map((score) => score.id));
    return scoresWithVariations.filter((row) => eligibleScoreIds.has(row.scoreId));
};

export const pickFirstSelectorVariation = (
    scoresWithVariations: ScoreWithVariation[],
    selectorScores: Score[],
): ScoreWithVariation | undefined => {
    const filtered = filterScoresWithVariationsForSelectors(scoresWithVariations, selectorScores);
    return filtered[0];
};
